const tabConfig = [
  {
    columnTitle: "Title",
    dataField: ["title"],
  },
  {
    columnTitle: "Description",
    dataField: ["description"],
  },
  {
    columnTitle: "Date",
    dataField: ["createdAt"],
  },
];

export default tabConfig;
